// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/images/dpslogotrans.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/bg-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/date-box.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

/* Make the main container take up remaining space */
#root,
.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* Full height of viewport */
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: visible !important;
  padding-right: 0 !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.popup .modal {
  opacity: 0;
  animation: fadeIn 1s ease-in forwards;
  transition: 0.3s ease-in-out;
}

.popup .modal .modal-content .modal-body button.btn-close {
  position: absolute;
  top: 15px;
  right: 15px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  z-index: 1051;
}

.news-update {
  background-color: orange;
  color: #043267;
  /* font-weight: 700; */
  height: 40px;
  padding-top: 5px;
}

.news-update h3 {
  font-size: 22px;
  font-weight: bold;
}

.news-update-list {
  background-color: #1b741e;
  height: 40px;
  margin: 0px;
  padding: 0px 10px;
}

.news-update-list ul {
  display: flex;
  list-style: none;
}

.news-update-list ul li {
  padding-right: 100px;
  padding-top: 5px;
}

.news-update-list ul li a {
  text-decoration: none;
  color: #fff;
  font-weight: bold;
}

.welcome-dps {
  text-align: justify;
}

.welcome-dps h3 {
  font-size: 35px;
}

.welcome-dps p {
  font-size: 18px;
  font-weight: 600;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 280px;
  background-position: center;
  background-repeat: no-repeat;
}

.notice-circular {
  height: 80%;
  /* border: 3px solid #084007; */
  margin-top: 30px;
}

.notice-circular marquee {
  width: 100%;
  padding-left: 0px;
}

.notice-circular ul {
  list-style: none;
}

.notice-circular ul li {
  padding-bottom: 8px;
}

.notice-circular ul li a {
  text-decoration: none;
  cursor: pointer;
  color: #00008b;
  font-weight: 700;
}

.inside-notice-circular {
  background-color: #084007;
  text-align: center;
  color: #fff;
  box-shadow: rgb(108, 108, 108) 0px 0px 1px 2px;
}

.inside-notice-circular h3 {
  font-size: 20px;
  padding: 10px 0px;
}

.about-img img {
  height: auto;
}

.blog-img {
  position: relative;
  overflow: hidden;
}

.blog-img a {
  cursor: pointer;
  text-decoration: none;
}

.blog-img img {
  transition: 0.5s;
  transform: scale(1, 1);
}

.blog-img :hover img {
  transform: scale(1.2, 1.2);
}

.blog-content {
  position: relative;
  background-color: orange;
  text-align: center;
  font-weight: 600;
  padding: 20px 20px 24px 24px;
}

.blog-content p {
  color: #fff;
  font-size: 32px;
  font-weight: 600;
  margin: 12px 0px 5px 0px;
}

.blog-content a {
  text-decoration: none;
  color: #fff;
}

.blog-content :hover a {
  color: #1b741e;
}

.event_gallery {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center center;
  background-size: cover;
}

.event_gallery h2 {
  font-size: 40px;
  margin: 20px 0;
}

.event_gallery .item {
  padding: 0 5px;
}


.slick-slide>div {
  margin: 0 10px;
}

.slick-list {
  margin: 0 -10px;
}

1 2 3 4 5 6 .slick-slide>div {
  margin: 0 10px;
}

.slick-list {
  margin: 0 -10px;
}

.event-img {
  position: relative;
  overflow: hidden;
}

.event-img a {
  cursor: pointer;
  text-decoration: none;
}

.event-img img {
  transition: 0.5s;
  transform: scale(1, 1);
}

.event-img :hover img {
  transform: scale(1.2, 1.2);
}

.event-content {
  position: relative;
  background-color: orange;
  text-align: center;
  font-weight: 600;
  padding: 20px 20px 24px 24px;
}

.event-content h3 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin: 12px 0px 5px 0px;
}

.event-content a {
  text-decoration: none;
  color: #fff;
}

.event-content :hover a {
  color: #1b741e;
}

.event-date-wrap {
  position: absolute;
  top: 16%;
  left: 0;
  transform: translateY(-50%);
  background-color: #00a651;
  padding: 12px 20px 12px;
}

.event-date-wrap span {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  display: block;
}

.event-date-wrap .event-date {
  margin-bottom: 5px;
}

.counter {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;
}

.counter-one::before {
  content: "";
  position: absolute;
  top: 8px;
  right: 7px;
  background-color: #e1dddd;
  width: 3px;
  height: 50px;
}

.counter-two::before {
  content: "";
  position: absolute;
  top: 10px;
  right: 20px;
  background-color: #e1dddd;
  width: 3px;
  height: 50px;
}

.counter-three::before {
  content: "";
  position: absolute;
  top: 8px;
  right: 20px;
  background-color: #e1dddd;
  width: 3px;
  height: 50px;
}

.counter-img {
  flex-basis: 54px;
  padding: 0px 25px;
}

.counter-content h2 {
  font-size: 40px;
  font-weight: bold;
  color: #00a651;
}

.counter-content span {
  font-size: 16px;
  font-weight: 500;
  color: #666666;
}

/* At a Glance CSS */
.atglance h3 {
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}

.atglance p {
  text-align: justify;
  font-size: 20px;
}

.ataglance-responsive-image {
  display: none;
  /* Hidden on desktop */
}

.atgalnce-images {
  display: block;
  /* Visible on desktop */
}


footer {
  margin-top: 50px;
  padding: 40px 0px 30px 0px;
  background-color: #043267;
  color: #fff;
}

footer .footer .footer-image {
  text-align: center;
}

.footer .footer-right {
  border-right: 1px groove #6a83a0;
}

.footer h6 {
  font-size: 16px;
}

.footer .quick-links {
  list-style: none;
}

.footer .quick-links li {
  padding-right: 5px;
}

.footer .quick-links li a {
  text-decoration: none;
  color: white;
}

.footer .address {
  list-style: none;
  padding: 5px 0px;
}

.footer .address li a {
  text-decoration: none;
  color: white;
  font-size: 15px;
}

.footer .connect-us {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.footer .connect-us li a {
  text-decoration: none;
  color: white;
  padding: 0 12px;
}

.bottom-layer {
  display: none;
}

.icons {
  display: block;
  position: fixed;
  bottom: 20%;
  right: 0px;
  z-index: 9999;
}

.icons div {
  margin-bottom: 10px;
}

.twittericons {
  width: 50px;
  height: 50px;
  font-size: 27px;
  background: black;
  text-align: center;
  margin: 3px;
  border-radius: 50%;
  padding: 5px;
}

.twittericons a {
  color: white;
}

.youtubeicon {
  width: 50px;
  height: 50px;
  font-size: 27px;
  background: red;
  text-align: center;
  margin: 3px;
  border-radius: 50%;
  padding: 5px;
}

.about-section li a {
  text-decoration: none !important;
  color: black;
}

.about-section li {
  font-size: 16px;
}

.about-button {
  background-color: #043267;
  color: #fff;
  padding: 2.5px 15px;
}

.youtubeicon a {
  color: white;
}

.facebookicons {
  width: 50px;
  height: 50px;
  font-size: 27px;
  background: blue;
  text-align: center;
  margin: 3px;
  border-radius: 50%;
  padding: 5px;
}

.facebookicons a {
  color: white;
}

.marquees {
  background-color: #1b741e;
  margin: auto;
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  padding-top: 5px;
}

.marquees a {
  text-decoration: none;
  color: #fff;
  cursor: pointer;
}

.modal {
  transition: 0.5s;
}

.top-header {
  background-color: #002147;
}

.contact-header {
  color: #fff;
}

.contact-header ul {
  list-style: none;
}

.contact-header ul li {
  padding: 10px 5px 0px 5px;
  font-size: 15px;
}

.contact-header ul li a {
  text-decoration: none;
  color: #fff;
  font-weight: 700;
}

.form-control {
  padding: 15px 12px;
  font-size: 15px;
  border: none;
  line-height: 1;
  border-bottom: 1px solid #ced4da
}

.navbar-brand img {
  width: 350px;
}

.nav-link {
  font-weight: bold;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.nav-item .nav-link {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 15px;
  color: #002147;
  text-transform: capitalize;
}

.navbar1 :hover {
  color: orange;
}

.dropdown-item {
  font-weight: bold;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

#navbarNavDropdown .dropdown:hover .dropdown-menu {
  display: block;
  transition: all 0.5s;
  margin-top: 0.125em;
}

#offcanvasRight {
  width: 85%;
}

#offcanvasRight .show {
  transform: inherit !important;
  position: static !important;
}

.dropdown-menu {
  display: block;
}

.dropdown {
  .dropdown-menu {
    transition: all 0.5s;
    overflow: hidden;
    transform-origin: top center;
    transform: scale(1, 0);
    display: block;
  }

  &:hover {
    .dropdown-menu {
      transform: scale(1);
    }
  }
}

.dropdown-menu .dropdown-item {
  font-weight: bold;
}

.dropdown-menu li a:hover {
  color: #00a651;
  padding-left: 20px;
  transition: .5s ease-in-out;
}

.dropdown-menu li a::before {
  background: #00a651 none repeat scroll 0 0;
  border-radius: 50%;
  content: "";
  height: 7px;
  left: 15px;
  opacity: 0;
  position: absolute;
  top: 13px;
  transition: all 0.3s ease-in-out 0s;
  width: 7px;
  z-index: 999;
}

.contact-details p {
  font-size: 14px;
}

.contact-details p a {
  text-decoration: none;
  color: #00008b;
  font-size: 14px;
}

.fee-structure h3 {
  color: orange;
  font-weight: bold;
}

.fee-structure h6 {
  color: darkblue;
  font-weight: 600;
}

.fee-structure table thead tr th {
  background-color: orange;
  color: white;
}

.fee-structure table thead tr th h6 {
  color: #fff;
  font-weight: 700;
  font-size: 20px;
}

.fee-structure table tbody tr td {
  font-size: 18px;
}

.subject-combination h3 {
  color: orange;
  font-weight: bold;
}

.subject-combination h4 {
  color: orange;
  font-weight: bold;
  padding-top: 40px;
}

.subject-combination h6 {
  color: darkblue;
  font-weight: 600;
}

.subject-combination table thead tr th {
  background-color: orange;
  color: white;
  font-size: 20px;
}

.subject-combination table tbody tr td {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 600;
}

.school-rules-heading h3 {
  background-color: maroon;
  color: #fff;
  text-align: center;
  font-size: 25px;
  padding: 12px 0;
  border: none;
  font-weight: bold;
}

.school-rules p {
  font-size: 20px;
}

.school-rules ol {
  text-align: justify;
}

.school-rules ol li {
  font-size: 18px;
}

.mpd {
  padding: 0 8%;
}

.mpd h3 {
  color: orange;
  font-weight: bold;
}

.page-heading {
  border-left: 8px solid #206AAA;
  padding-left: 10px;
}

.mpd table thead tr th {
  background-color: maroon;
  color: white;
}

table {
  width: 100%;
  margin-top: 10px;
  /* font-size: 18px; */
}

thead tr th {
  text-align: center;
  font-weight: bold;
}

.wing h2 {
  text-align: center;
  padding: 5px 0;
  font-weight: 800;
  background-color: darkgreen;
  color: orange;
  font-size: 40px;
}

.wing p {
  font-size: 17px;
  margin: 5px 20px 0 20px;
  text-align: justify;
}

.wing h4 {
  margin: 10px 20px 0px 20px;
  color: orange;
  font-weight: 800;
  font-size: 25px;
}

.alumni-register label {
  margin-bottom: 5px;
  font-weight: bold;
}

.alumni-register label span {
  color: red;
  padding-left: 3px;
}

.alumni-register input {
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  margin-bottom: 10px;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-button input {
  width: 10%;
}

#authoritiesMessages {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center center;
}

#authoritiesMessages .row {
  align-items: center;
  margin-top: 25px !important;
  padding-top: 20px;
}

.authorities_message h3 {
  font-size: 18px;
  text-transform: uppercase;
  padding-left: 10px;
  font-weight: bold;
  margin: 10px 0;
  color: #002147;
}

.authorities_message .message h2 {
  font-size: 18px;
  font-weight: 700;
}

.authorities_message .message p {
  text-align: justify;
  font-size: 18px;
}

.authorities_message .image img {
  border: 4px solid #002147;
}

.authorities_message .icon .youtube_icon {
  padding-left: 25px;
  color: red;
  font-size: 45px;
}

.authorities_message .icon .blog_icon {
  padding-left: 20px;
  font-size: 45px;
}

.vision_and_mission {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center center;
  background-size: cover;
}

/* Infrastructure CSS */
.infrastructure ul.nav {
  position: relative;
}

.infrastructure .nav .nav-link {
  color: black;
}

.infrastructure .nav.nav-pills {
  justify-content: center;
  align-items: center;
}

.infrastructure .nav-pills li {
  display: block;
  min-width: 200px;
}

.infrastructure .nav-pills li .nav-link {
  font-size: 20px;
  color: black;
  text-transform: capitalize;
  font-weight: 500;
  display: inline-block;
  transition: 0.3s;
  border: 2px solid #ebebeb;
  background-color: orange;
  width: 250px;
}

.infrastructure .nav-pills li .nav-link.active {
  position: relative;
  color: white !important;
  background: #0d6efd;
}

.infrastructure .nav-pills li .nav-link.active::before {
  position: absolute;
  content: "";
  width: 102%;
  height: 109%;
  border: 2px solid #c09578;
  left: -2px;
  top: -2px;
  /* border-radius: 2px; */
}

.infrastructure .tab-content .tab-pane h3 {
  border-bottom: 2px solid #002147;
  border-top: 2px solid #002147;
  margin-top: 30px;
  padding: 20px 0 25px;
  text-align: center;
  color: orange;
  font-weight: bold;
}

.infrastructure .tab-content .tab-pane p {
  font-size: 18px;
  font-family: "Roboto", sans-serif;
}

.infrastructure .tab-content .tab-pane h5 {
  font-size: 24px;
  color: maroon;
  font-weight: bold;
  font-family: "Roboto", sans-serif;
}

.infrastructure .tab-content .tab-pane ol li {
  font-size: 18px;
  font-family: "Roboto", sans-serif;
}

.infrastructure .tab-content .tab-pane ul li {
  font-size: 18px;
  font-family: "Roboto", sans-serif;
}

.virtualTour h3 {
  font-size: 30px;
  border-left: 5px solid #00a651;
  padding-left: 10px;
  font-weight: bold;
  margin: 2% 0;
  color: #002147;
}

.virtualTour h3 span {
  color: #00a651;
}

.fraternity {
  text-align: center;
}

.fraternity h2 {
  color: orange;
  font-weight: 700;
}

.fraternity .img-fluid {
  height: 200px;
}

.fraternity h6 {
  padding: 0px 10px;
  color: maroon;
  font-weight: bold;
  font-size: 14px;
}

.fraternity .teacher-name {
  color: darkblue;
  font-weight: bold;
  text-transform: uppercase;
}

/*  */
.Teachers-faculties .teachers-name {
  color: darkblue;
  font-weight: bold;
}

.Teachers-faculties h4 {
  background-color: orange;
  padding: 10px 0px;
  color: #002147;
  font-weight: bold;
  font-size: 22px;
}

.Teachers-faculties h6 {
  color: maroon;
  font-weight: bold;
}

.Teachers-faculties p a {
  text-decoration: none;
  color: maroon;
  font-weight: bold;
}

.Teachers-faculties p a i {
  padding-right: 5px;
}

.teacher-wings-button ul.nav {
  position: relative;
}

.teacher-wings-button .nav .nav-link {
  color: black;
}

.teacher-wings-button ul li {
  display: block;
}

.teacher-wings-button ul li a {
  font-size: 20px;
  color: black;
  text-transform: capitalize;
  font-weight: 500;
  display: inline-block;
  transition: 0.3s;
  border: 2px solid #ebebeb;
  min-width: 190px;
}

.teacher-wings-button ul li a.active {
  position: relative;
  color: #c09578 !important;
}

.teacher-wings-button ul li a.active::before {
  position: absolute;
  content: "";
  width: 102%;
  height: 109%;
  border: 2px solid #c09578;
  left: -2px;
  top: -2px;
  border-radius: 2px;
}

.wings-contents .teachers-name {
  color: darkblue;
  font-weight: bold;
}

.wings-contents h4 {
  background-color: orange;
  padding: 10px 0px;
  color: #002147;
  font-weight: bold;
  font-size: 22px;
}

.wings-contents h6 {
  color: maroon;
  font-weight: bold;
  font-size: 14px;
}

.wings-contents p {
  font-size: 14px;
}

.wings-contents p a {
  text-decoration: none;
  color: maroon;
  font-weight: bold;
  font-size: 14px;
}

.admission-policy {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.admission-policy h3 {
  color: orange;
  font-weight: bold;
}

.admission-policy ol li {
  padding: 10px 0;
  font-size: 18px;
}

.exam-policy {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.exam-policy table thead tr th {
  background-color: orange;
  color: #fff;
}

.exam-policy table thead tr th h4 {
  font-weight: bold;
}

.exam-policy table thead tr th h6 {
  font-weight: bold;
}

.hostel-policy {
  font-family: Verdana, Geneva, Tahoma, sans-serif;

}

.hostel-policy h3 {
  color: orange;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
}

.hostel-policy p {
  font-size: 18px;
}

.hostel-policy ol li {
  padding: 8px 0;
  font-size: 18px;
}

.hostel-policy .formalitiesHostel {
  padding-left: 30px;
}

.exam-policy .table-3 {
  width: 80%;
}

/* Admin Login */
.carousel .carousel-inner .carousel-item img.admin-img {
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0;
}

.admin-form {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  background-color: white;
  padding: 25px;
  border-radius: 20px;
}

.sidebar {
  width: 220px;
}

.list-group a:hover {
  cursor: pointer;
}

.document-form-1 {
  margin: 20px 50px 50px 50px;
  width: 91%;
  background-color: white;
  padding: 25px;
  border-radius: 20px;
  border: 2px solid black;
}

/* School Magazine */
.school-magazine {
  text-align: center;
}

.school-magazine iframe {
  width: 900px;
  height: 475px;
}

/*  */
.admission-procedure ul.nav {
  position: relative;
}

.admission-procedure .nav .nav-link {
  color: black;
}

.admission-procedure .nav.nav-pills {
  justify-content: center;
  align-items: center;
}

.admission-procedure .nav-pills li {
  display: block;
  min-width: 200px;
}

.admission-procedure .nav-pills li .nav-link {
  font-size: 20px;
  color: black;
  text-transform: capitalize;
  font-weight: 500;
  display: inline-block;
  transition: 0.3s;
  border: 2px solid #ebebeb;
  background-color: orange;
  width: 250px;
}

.admission-procedure .nav-pills li .nav-link.active {
  position: relative;
  color: white !important;
  background: #0d6efd;
}

.admission-procedure .nav-pills li .nav-link.active::before {
  position: absolute;
  content: "";
  width: 102%;
  height: 109%;
  border: 2px solid #c09578;
  left: -2px;
  top: -2px;
  /* border-radius: 2px; */
}

.admission-procedure .tab-content .tab-pane h3 {
  border-bottom: 2px solid #002147;
  border-top: 2px solid #002147;
  margin-top: 30px;
  padding: 20px 0 25px;
  text-align: center;
  color: orange;
  font-weight: bold;
}

.admission-procedure .tab-content .tab-pane p {
  font-size: 18px;
  font-family: "Roboto", sans-serif;
}

.admission-procedure .tab-content .tab-pane h5 {
  font-size: 24px;
  color: maroon;
  font-weight: bold;
  font-family: "Roboto", sans-serif;
}

.admission-procedure .tab-content .tab-pane ol li {
  font-size: 18px;
  font-family: "Roboto", sans-serif;
}

.admission-procedure .tab-content .tab-pane ul li {
  font-size: 18px;
  font-family: "Roboto", sans-serif;
}

/* Achievement */
.all-achievement ul.nav {
  position: relative;
}

.all-achievement .nav .nav-link {
  color: black;
  text-align: center;
}

.all-achievement .nav {
  justify-content: center;
  align-items: center;
}

.all-achievement li .nav-link {
  font-size: 20px;
  color: black;
  text-transform: capitalize;
  font-weight: bold;
  display: inline-block;
  transition: 0.3s;
  border: 2px solid #ebebeb;
  background-color: orange;
  width: 180px;
}

.all-achievement li .nav-link.active {
  position: relative;
  color: white !important;
  background: #0d6efd;
}

.all-achievement li .nav-link.active::before {
  position: absolute;
  content: "";
  width: 102%;
  height: 109%;
  border: 2px solid #c09578;
  left: -2px;
  top: -2px;
  /* border-radius: 2px; */
}

.card-date {
  padding: 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
  margin: auto;
  background-size: contain;
}

.card-date .year {
  font-weight: 700;
  font-size: 13px;
  text-align: center;
  border-radius: 20px;
}

.card-date .month {
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  text-align: center;

}

.card-date .day {
  font-weight: bold;
  font-size: 20px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
}

/* School Circular */
.school-circular {
  display: flex;
  justify-content: center;
}

.school-circular .table {
  width: 70%;
  display: inline-table;
}

.school-circular .table .download_heading {
  font-size: 18px;
  font-weight: bold;
}

.school-circular table thead th.action {
  width: 100px;
}

.school-circular table tbody tr td a button.viewbutton {
  max-width: 45%;
  margin-right: 2px;
}

/* Add this to your CSS */
.lightbox-js img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.sidebar .list-group.list-group-flush a {
  background-color: rgb(48, 42, 42);
}

.sidebar .list-group-item {
  background-color: rgb(48, 42, 42);
  color: white;
  border: none;
}

/* Student Council CSS */
.student-council-image img {
  opacity: 0;
  animation: fadeIn 2s ease-in forwards;
  transform: scale(1, 1);
  transition: 0.2s ease-in-out;
}

.student-council-image img:hover {
  transform: scale(1.1, 1.1);
}

.student_council_table table {
  width: 85%;
  margin-top: 15px;
}

.student_council_table .table>:not(caption)>*>* {
  padding: .1rem .1rem;
}

.student_council_table table thead tr th {
  background-color: orange;
}

.student_council_table table tbody {
  vertical-align: middle;
}

.student_council_table table tbody tr td.house-name {
  padding-left: 15px;
}


/* BackToTopButton.css */
.back-to-top-btn {
  position: fixed;
  bottom: 40px;
  right: 40px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
  opacity: 0.8;
  z-index: 9999;
}

.back-to-top-btn:hover {
  opacity: 1;
  background-color: #0056b3;
  /* Darker shade on hover */
}

.newsletter {
  flex: 1 1;
  /* Takes up remaining space */
}

.school_news {
  flex: 1 1;
  /* Takes up remaining space */
}

.Achievement {
  flex: 1 1;
  /* Takes up remaining space */
}

.download {
  flex: 1 1;
  /* Takes up remaining space */
}

.school_circular {
  flex: 1 1;
  /* Takes up remaining space */
}

.TramsferCertificate {
  flex: 1 1;
}

@media only screen and (min-width: 0px) and (max-width: 767px) {
  .icons {
    display: none;
  }

  .contact-header {
    display: none;
  }

  .contact-header ul li {
    padding: 0;
    font-size: 13px;
  }

  .contact-header .laptop ul li {
    font-size: 13px;
    padding-right: 5px;
  }

  .social-icons {
    display: none;
  }

  .navbar-brand img {
    width: 250px;
  }

  .dropdown-menu {
    display: none;
  }

  .dropdown {
    .dropdown-menu {
      transition: all ease .5s;
      overflow: hidden;
      transform-origin: top center;
      transform: scale(1, 0);
      display: none;
    }

    &:hover {
      .dropdown-menu {
        transform: scale(1);
      }
    }
  }

  .slider video {
    height: 128px;
  }

  .news-update h3 {
    font-size: 20px;
    padding: 0;
    margin: 0;
  }

  .news-update-list {
    margin: 0;
    padding: 0;
  }

  .news-update-list ul li {
    padding-top: 10px;
  }

  .welcome-dps h3 {
    font-size: 25px;
  }

  .welcome-dps p {
    font-size: 15px;
    background-size: contain;
    animation-name: none;
  }

  .notice-circular {
    animation-name: none;
  }

  .about-img img {
    height: 250px;
  }

  .counter-content h2 {
    font-size: 33px;
  }

  .counter {
    justify-content: flex-start;
    padding: 10px 0;
  }

  .counter-one::before {
    content: "";
    display: none;
  }

  .counter-three::before {
    content: "";
    display: none;
  }

  .counter-two::before {
    content: "";
    display: none;
  }

  .counter-img {
    padding: 0px 70px;
  }

  /* About */
  .about-dps h3 {
    font-size: 25px;
    font-weight: 500;
  }

  .dps-vision h3 {
    font-size: 25px;
    font-weight: 500;
  }

  .mission-dps h3 {
    font-size: 25px;
    font-weight: 500;
  }

  .principal-message h3 {
    font-size: 25px;
    font-weight: 500;
  }

  .principal-message h5 {
    font-size: 17px;
  }

  .about-dps-society h3 {
    font-size: 25px;
    font-weight: 500;
  }

  /* At a Glance */
  .atglance h3 {
    font-size: 25px;
  }

  .atglance p {
    font-size: 16px;
  }

  .ataglance-responsive-image {
    display: block;
    /* Show the responsive image on smaller screens */
    width: 100%;
    height: auto;
  }

  .atgalnce-images {
    display: none;
    /* Hide the images div on smaller screens */
  }

  /*  */
  .fraternity h2 {
    font-size: 20px;
    font-weight: 700;
  }

  .fraternity h6 {
    padding: 0px 20px;
  }

  .Teachers-faculties p {
    font-weight: 500;
  }


  /*  */
  footer {
    padding: 0px 0px 30px 0px;
  }

  .footer {
    padding: 0px;
    border: 0px;
  }

  .footer .get-in-touch {
    border-right: 0px groove #6a83a0;
    text-align: center;
  }


  .footer .footer-right {
    border-right: 0;
  }

  .footer h6 {
    border-top: 1px solid #6a83a0;
    padding-top: 35px;
    margin-top: 35px;
  }

  .footer-1 h6 {
    border-top: 0;
  }

  /*  */
  .mpd {
    padding: 0;
  }

  table {
    max-width: 100%;
    margin-top: 10px;
    font-size: 12px;
  }

  /*  */
  .payment-note ul li {
    font-size: 15px;
  }

  /*  */
  .form-button {
    text-align: center !important;
  }

  .form-button input {
    width: 30%;
  }

  /* school Rules */
  .school-rules-heading h3 {
    font-size: 15px;
  }

  .school-rules p {
    font-size: 16px;
  }

  .school-rules ol li {
    font-size: 15px;
  }

  .events-gallery h2 {
    font-size: 30px;
    margin: 0 0 20px;
  }

  /*  */
  /* .authorities_message h3 {
    margin-left: 10px;
  } */
  .bisque_authoritites_message {
    margin-top: 50px;
  }

  .blue_authorities_message {
    margin-top: 50px;
  }

  .authorities_message .image img {
    width: 230px;
    margin-top: -2%;
    padding-left: 0;
  }

  .authorities_message .image img.director-image {
    margin-top: 0;
  }

  .authorities_message .message h2 {
    font-size: 18px;
    font-weight: 700;
  }

  .authorities_message .image h2 {
    padding-left: 0;
    ;
  }

  .authorities_message .message p {
    text-align: justify;
    font-size: 16px;
  }

  .authorities_message .image h3 {
    padding-left: 0;
    font-size: 20px;
  }

  .authorities_message .icon .youtube_icon {
    padding-left: 60px;
  }

  .authorities_message .icon .blog_icon {
    padding-left: 20px;
  }

  .virtualTour iframe {
    height: 300px;
  }

  /*  */
  .bottom-layer {
    display: block;
    background: #9e801a;
    position: fixed;
    bottom: 0px;
    width: 100% !important;
    height: 40px;
    color: #fff;
    text-align: center;
    z-index: 999999;
  }

  .bottom-layer a {
    color: white;
    text-decoration: none;
    font-size: 13px;
  }

  .explore-us h3 {
    font-size: 30px;
    font-weight: 500;
  }

  .explore-us iframe {
    height: 350px;
  }

  .exam-policy table.table-2 {
    font-size: 6px !important;
  }

  .exam-policy .table-3 {
    width: 100%;
  }

  .sidebar {
    width: 120px;
  }

  .school-magazine iframe {
    width: 320px;
    height: 400px;
  }

  .admission-procedure .nav {
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .admission-procedure .tab-content {
    padding: 0 20px;
  }

  .all-achievement .nav {
    display: flex;
    flex-direction: column;
  }

  .all-achievement li .nav-link {
    width: 200px;
  }

  .school-circular {
    display: block;
  }

  .school-circular table {
    width: 100% !important;
  }

  .school-circular .table .download_heading {
    font-size: 15px;
    font-weight: bold;
  }


  .slick-slider button.slick-prev {
    left: -10px;
  }

  .slick-slider button.slick-next {
    right: -10px;
  }

  .student_council_table table {
    width: 100%;
  }

  .student_council_table .table>:not(caption)>*>* {
    padding: 0px;
  }

  .student_council_table table tbody tr td.house-name {
    padding: 5px;
  }

  .fee-structure table thead tr th h6 {
    font-size: 16px;
  }

  .fee-structure table tbody tr td {
    font-size: 14px;
  }

  .subject-combination table thead tr th {
    font-size: 16px;
  }

  .subject-combination table tbody tr td {
    font-size: 14px;
  }

}


@media only screen and (min-width: 768px) and (max-width: 991px) {
  .contact-header {
    display: none;
  }

  .social-icons {
    display: none;
  }

  #offcanvasRight {
    width: 50%;
  }

  .dropdown-menu {
    display: none;
  }

  .dropdown {
    .dropdown-menu {
      transition: all ease .5s;
      overflow: hidden;
      transform-origin: top center;
      transform: scale(1, 0);
      display: none;
    }

    &:hover {
      .dropdown-menu {
        transform: scale(1);
      }
    }
  }

  .authorities_message .image img {
    width: 230px;
    margin-top: -20%;
    padding-left: 0;
  }

  .authorities_message .images img {
    width: 230px;
    padding-left: 0;
  }

  .authorities_message .image h2 {
    padding-left: 0;
    ;
  }

  .authorities_message .image h3 {
    padding-left: 0;
    font-size: 20px;
  }

  .counter {
    justify-content: flex-start;
  }

  .counter-one::before {
    content: "";
    position: absolute;
    top: 8px;
    right: 12px;
    background-color: #e1dddd;
    width: 3px;
    height: 50px;
  }

  .counter-two::before {
    content: "";
    display: none;
    position: absolute;
    top: 10px;
    right: 20px;
    background-color: #e1dddd;
    width: 3px;
    height: 50px;
  }

  .counter-three::before {
    content: "";
    position: absolute;
    top: 8px;
    right: 12px;
    background-color: #e1dddd;
    width: 3px;
    height: 50px;
  }

  /* At a Glance */
  .atglance h3 {
    text-align: center;
    font-size: 30px;
    font-weight: 500;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }

  .atglance p {
    text-align: justify;
    font-size: 18px;
  }

  .ataglance-responsive-image {
    display: block;
    /* Show the responsive image on smaller screens */
    width: 100%;
    height: auto;
  }

  .atgalnce-images {
    display: none;
    /* Hide the images div on smaller screens */
  }

  .exam-policy .table-3 {
    width: 100%;
  }

  .sidebar {
    width: 120px;
  }

  .school-magazine iframe {
    width: 650px;
    height: 550px;
  }

  .admission-procedure .nav.nav-pills {
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .admission-procedure .tab-content {
    padding: 0 20px;
  }

  .slick-slider button.slick-prev {
    left: -10px;
  }

  .slick-slider button.slick-next {
    right: -10px;
  }

  .student_council_table table {
    width: 100%;
  }

  footer {
    padding: 0px 0px 30px 0px;
  }

  .footer {
    padding: 0px;
    border: 0px;
  }

  .footer .get-in-touch {
    border-right: 0px groove #6a83a0;
    text-align: center;
  }

  .footer .footer-right {
    border-right: 0;
  }

  .footer h6 {
    border-top: 1px solid #6a83a0;
    padding-top: 35px;
    margin-top: 35px;
  }

  .footer-1 h6 {
    border-top: 0;
  }

}


@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .contact-header .laptop ul li {
    padding-left: 4px;
    padding-right: 4px;
  }

  .navbar-brand img {
    width: 220px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;;EAEE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;aACW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAqD;EACrD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yDAAwC;EACxC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mJAAmJ;AACrJ;;AAEA;EACE,mJAAmJ;EACnJ,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mJAAmJ;AACrJ;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,mCAAmC;EACnC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yDAAwC;EACxC,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yDAAwC;EACxC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,KAAK;AACL;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;;AAElD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,KAAK;AACL;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,2EAA8D;EAC9D,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,qCAAqC;EACrC,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;MACE,wBAAwB;MACxB,gBAAgB;MAChB,4BAA4B;MAC5B,sBAAsB;MACtB,aAAa;IACf;;IAEA;MACE;QACE,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA,UAAU;EACV;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iDAAiD;IACjD,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,2CAA2C;EAC7C;;EAEA,KAAK;EACL;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA,KAAK;EACL;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;EACpB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,KAAK;EACL;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA,KAAK;EACL;IACE,eAAe;EACjB;;EAEA,KAAK;EACL;IACE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA,iBAAiB;EACjB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,KAAK;EACL;;KAEG;EACH;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;;EAEjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA,KAAK;EACL;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;MACE,wBAAwB;MACxB,gBAAgB;MAChB,4BAA4B;MAC5B,sBAAsB;MACtB,aAAa;IACf;;IAEA;MACE;QACE,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;;EAEjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,YAAY;EACd;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wEAAwE;EAC1E;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iDAAiD;IACjD,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,2CAA2C;EAC7C;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF;;;AAGA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["html,\nbody {\n  height: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Make the main container take up remaining space */\n#root,\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  /* Full height of viewport */\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow: visible !important;\n  padding-right: 0 !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.popup .modal {\n  opacity: 0;\n  animation: fadeIn 1s ease-in forwards;\n  transition: 0.3s ease-in-out;\n}\n\n.popup .modal .modal-content .modal-body button.btn-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  z-index: 1051;\n}\n\n.news-update {\n  background-color: orange;\n  color: #043267;\n  /* font-weight: 700; */\n  height: 40px;\n  padding-top: 5px;\n}\n\n.news-update h3 {\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.news-update-list {\n  background-color: #1b741e;\n  height: 40px;\n  margin: 0px;\n  padding: 0px 10px;\n}\n\n.news-update-list ul {\n  display: flex;\n  list-style: none;\n}\n\n.news-update-list ul li {\n  padding-right: 100px;\n  padding-top: 5px;\n}\n\n.news-update-list ul li a {\n  text-decoration: none;\n  color: #fff;\n  font-weight: bold;\n}\n\n.welcome-dps {\n  text-align: justify;\n}\n\n.welcome-dps h3 {\n  font-size: 35px;\n}\n\n.welcome-dps p {\n  font-size: 18px;\n  font-weight: 600;\n  background-image: url(../src/images/dpslogotrans.gif);\n  background-size: 280px;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.notice-circular {\n  height: 80%;\n  /* border: 3px solid #084007; */\n  margin-top: 30px;\n}\n\n.notice-circular marquee {\n  width: 100%;\n  padding-left: 0px;\n}\n\n.notice-circular ul {\n  list-style: none;\n}\n\n.notice-circular ul li {\n  padding-bottom: 8px;\n}\n\n.notice-circular ul li a {\n  text-decoration: none;\n  cursor: pointer;\n  color: #00008b;\n  font-weight: 700;\n}\n\n.inside-notice-circular {\n  background-color: #084007;\n  text-align: center;\n  color: #fff;\n  box-shadow: rgb(108, 108, 108) 0px 0px 1px 2px;\n}\n\n.inside-notice-circular h3 {\n  font-size: 20px;\n  padding: 10px 0px;\n}\n\n.about-img img {\n  height: auto;\n}\n\n.blog-img {\n  position: relative;\n  overflow: hidden;\n}\n\n.blog-img a {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.blog-img img {\n  transition: 0.5s;\n  transform: scale(1, 1);\n}\n\n.blog-img :hover img {\n  transform: scale(1.2, 1.2);\n}\n\n.blog-content {\n  position: relative;\n  background-color: orange;\n  text-align: center;\n  font-weight: 600;\n  padding: 20px 20px 24px 24px;\n}\n\n.blog-content p {\n  color: #fff;\n  font-size: 32px;\n  font-weight: 600;\n  margin: 12px 0px 5px 0px;\n}\n\n.blog-content a {\n  text-decoration: none;\n  color: #fff;\n}\n\n.blog-content :hover a {\n  color: #1b741e;\n}\n\n.event_gallery {\n  background-image: url(./images/bg-3.jpg);\n  background-position: center center;\n  background-size: cover;\n}\n\n.event_gallery h2 {\n  font-size: 40px;\n  margin: 20px 0;\n}\n\n.event_gallery .item {\n  padding: 0 5px;\n}\n\n\n.slick-slide>div {\n  margin: 0 10px;\n}\n\n.slick-list {\n  margin: 0 -10px;\n}\n\n1 2 3 4 5 6 .slick-slide>div {\n  margin: 0 10px;\n}\n\n.slick-list {\n  margin: 0 -10px;\n}\n\n.event-img {\n  position: relative;\n  overflow: hidden;\n}\n\n.event-img a {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.event-img img {\n  transition: 0.5s;\n  transform: scale(1, 1);\n}\n\n.event-img :hover img {\n  transform: scale(1.2, 1.2);\n}\n\n.event-content {\n  position: relative;\n  background-color: orange;\n  text-align: center;\n  font-weight: 600;\n  padding: 20px 20px 24px 24px;\n}\n\n.event-content h3 {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 12px 0px 5px 0px;\n}\n\n.event-content a {\n  text-decoration: none;\n  color: #fff;\n}\n\n.event-content :hover a {\n  color: #1b741e;\n}\n\n.event-date-wrap {\n  position: absolute;\n  top: 16%;\n  left: 0;\n  transform: translateY(-50%);\n  background-color: #00a651;\n  padding: 12px 20px 12px;\n}\n\n.event-date-wrap span {\n  color: #fff;\n  font-size: 18px;\n  font-weight: bold;\n  display: block;\n}\n\n.event-date-wrap .event-date {\n  margin-bottom: 5px;\n}\n\n.counter {\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.counter-one::before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  right: 7px;\n  background-color: #e1dddd;\n  width: 3px;\n  height: 50px;\n}\n\n.counter-two::before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  background-color: #e1dddd;\n  width: 3px;\n  height: 50px;\n}\n\n.counter-three::before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  right: 20px;\n  background-color: #e1dddd;\n  width: 3px;\n  height: 50px;\n}\n\n.counter-img {\n  flex-basis: 54px;\n  padding: 0px 25px;\n}\n\n.counter-content h2 {\n  font-size: 40px;\n  font-weight: bold;\n  color: #00a651;\n}\n\n.counter-content span {\n  font-size: 16px;\n  font-weight: 500;\n  color: #666666;\n}\n\n/* At a Glance CSS */\n.atglance h3 {\n  text-align: center;\n  font-size: 35px;\n  font-weight: 500;\n  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;\n}\n\n.atglance p {\n  text-align: justify;\n  font-size: 20px;\n}\n\n.ataglance-responsive-image {\n  display: none;\n  /* Hidden on desktop */\n}\n\n.atgalnce-images {\n  display: block;\n  /* Visible on desktop */\n}\n\n\nfooter {\n  margin-top: 50px;\n  padding: 40px 0px 30px 0px;\n  background-color: #043267;\n  color: #fff;\n}\n\nfooter .footer .footer-image {\n  text-align: center;\n}\n\n.footer .footer-right {\n  border-right: 1px groove #6a83a0;\n}\n\n.footer h6 {\n  font-size: 16px;\n}\n\n.footer .quick-links {\n  list-style: none;\n}\n\n.footer .quick-links li {\n  padding-right: 5px;\n}\n\n.footer .quick-links li a {\n  text-decoration: none;\n  color: white;\n}\n\n.footer .address {\n  list-style: none;\n  padding: 5px 0px;\n}\n\n.footer .address li a {\n  text-decoration: none;\n  color: white;\n  font-size: 15px;\n}\n\n.footer .connect-us {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.footer .connect-us li a {\n  text-decoration: none;\n  color: white;\n  padding: 0 12px;\n}\n\n.bottom-layer {\n  display: none;\n}\n\n.icons {\n  display: block;\n  position: fixed;\n  bottom: 20%;\n  right: 0px;\n  z-index: 9999;\n}\n\n.icons div {\n  margin-bottom: 10px;\n}\n\n.twittericons {\n  width: 50px;\n  height: 50px;\n  font-size: 27px;\n  background: black;\n  text-align: center;\n  margin: 3px;\n  border-radius: 50%;\n  padding: 5px;\n}\n\n.twittericons a {\n  color: white;\n}\n\n.youtubeicon {\n  width: 50px;\n  height: 50px;\n  font-size: 27px;\n  background: red;\n  text-align: center;\n  margin: 3px;\n  border-radius: 50%;\n  padding: 5px;\n}\n\n.about-section li a {\n  text-decoration: none !important;\n  color: black;\n}\n\n.about-section li {\n  font-size: 16px;\n}\n\n.about-button {\n  background-color: #043267;\n  color: #fff;\n  padding: 2.5px 15px;\n}\n\n.youtubeicon a {\n  color: white;\n}\n\n.facebookicons {\n  width: 50px;\n  height: 50px;\n  font-size: 27px;\n  background: blue;\n  text-align: center;\n  margin: 3px;\n  border-radius: 50%;\n  padding: 5px;\n}\n\n.facebookicons a {\n  color: white;\n}\n\n.marquees {\n  background-color: #1b741e;\n  margin: auto;\n  font-weight: 600;\n  font-size: 16px;\n  color: #fff;\n  padding-top: 5px;\n}\n\n.marquees a {\n  text-decoration: none;\n  color: #fff;\n  cursor: pointer;\n}\n\n.modal {\n  transition: 0.5s;\n}\n\n.top-header {\n  background-color: #002147;\n}\n\n.contact-header {\n  color: #fff;\n}\n\n.contact-header ul {\n  list-style: none;\n}\n\n.contact-header ul li {\n  padding: 10px 5px 0px 5px;\n  font-size: 15px;\n}\n\n.contact-header ul li a {\n  text-decoration: none;\n  color: #fff;\n  font-weight: 700;\n}\n\n.form-control {\n  padding: 15px 12px;\n  font-size: 15px;\n  border: none;\n  line-height: 1;\n  border-bottom: 1px solid #ced4da\n}\n\n.navbar-brand img {\n  width: 350px;\n}\n\n.nav-link {\n  font-weight: bold;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.nav-item .nav-link {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: 15px;\n  color: #002147;\n  text-transform: capitalize;\n}\n\n.navbar1 :hover {\n  color: orange;\n}\n\n.dropdown-item {\n  font-weight: bold;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n#navbarNavDropdown .dropdown:hover .dropdown-menu {\n  display: block;\n  transition: all 0.5s;\n  margin-top: 0.125em;\n}\n\n#offcanvasRight {\n  width: 85%;\n}\n\n#offcanvasRight .show {\n  transform: inherit !important;\n  position: static !important;\n}\n\n.dropdown-menu {\n  display: block;\n}\n\n.dropdown {\n  .dropdown-menu {\n    transition: all 0.5s;\n    overflow: hidden;\n    transform-origin: top center;\n    transform: scale(1, 0);\n    display: block;\n  }\n\n  &:hover {\n    .dropdown-menu {\n      transform: scale(1);\n    }\n  }\n}\n\n.dropdown-menu .dropdown-item {\n  font-weight: bold;\n}\n\n.dropdown-menu li a:hover {\n  color: #00a651;\n  padding-left: 20px;\n  transition: .5s ease-in-out;\n}\n\n.dropdown-menu li a::before {\n  background: #00a651 none repeat scroll 0 0;\n  border-radius: 50%;\n  content: \"\";\n  height: 7px;\n  left: 15px;\n  opacity: 0;\n  position: absolute;\n  top: 13px;\n  transition: all 0.3s ease-in-out 0s;\n  width: 7px;\n  z-index: 999;\n}\n\n.contact-details p {\n  font-size: 14px;\n}\n\n.contact-details p a {\n  text-decoration: none;\n  color: #00008b;\n  font-size: 14px;\n}\n\n.fee-structure h3 {\n  color: orange;\n  font-weight: bold;\n}\n\n.fee-structure h6 {\n  color: darkblue;\n  font-weight: 600;\n}\n\n.fee-structure table thead tr th {\n  background-color: orange;\n  color: white;\n}\n\n.fee-structure table thead tr th h6 {\n  color: #fff;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.fee-structure table tbody tr td {\n  font-size: 18px;\n}\n\n.subject-combination h3 {\n  color: orange;\n  font-weight: bold;\n}\n\n.subject-combination h4 {\n  color: orange;\n  font-weight: bold;\n  padding-top: 40px;\n}\n\n.subject-combination h6 {\n  color: darkblue;\n  font-weight: 600;\n}\n\n.subject-combination table thead tr th {\n  background-color: orange;\n  color: white;\n  font-size: 20px;\n}\n\n.subject-combination table tbody tr td {\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.school-rules-heading h3 {\n  background-color: maroon;\n  color: #fff;\n  text-align: center;\n  font-size: 25px;\n  padding: 12px 0;\n  border: none;\n  font-weight: bold;\n}\n\n.school-rules p {\n  font-size: 20px;\n}\n\n.school-rules ol {\n  text-align: justify;\n}\n\n.school-rules ol li {\n  font-size: 18px;\n}\n\n.mpd {\n  padding: 0 8%;\n}\n\n.mpd h3 {\n  color: orange;\n  font-weight: bold;\n}\n\n.page-heading {\n  border-left: 8px solid #206AAA;\n  padding-left: 10px;\n}\n\n.mpd table thead tr th {\n  background-color: maroon;\n  color: white;\n}\n\ntable {\n  width: 100%;\n  margin-top: 10px;\n  /* font-size: 18px; */\n}\n\nthead tr th {\n  text-align: center;\n  font-weight: bold;\n}\n\n.wing h2 {\n  text-align: center;\n  padding: 5px 0;\n  font-weight: 800;\n  background-color: darkgreen;\n  color: orange;\n  font-size: 40px;\n}\n\n.wing p {\n  font-size: 17px;\n  margin: 5px 20px 0 20px;\n  text-align: justify;\n}\n\n.wing h4 {\n  margin: 10px 20px 0px 20px;\n  color: orange;\n  font-weight: 800;\n  font-size: 25px;\n}\n\n.alumni-register label {\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.alumni-register label span {\n  color: red;\n  padding-left: 3px;\n}\n\n.alumni-register input {\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  margin-bottom: 10px;\n  font-size: 15px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.form-button input {\n  width: 10%;\n}\n\n#authoritiesMessages {\n  background-image: url(./images/bg-3.jpg);\n  background-size: cover;\n  background-position: center center;\n}\n\n#authoritiesMessages .row {\n  align-items: center;\n  margin-top: 25px !important;\n  padding-top: 20px;\n}\n\n.authorities_message h3 {\n  font-size: 18px;\n  text-transform: uppercase;\n  padding-left: 10px;\n  font-weight: bold;\n  margin: 10px 0;\n  color: #002147;\n}\n\n.authorities_message .message h2 {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.authorities_message .message p {\n  text-align: justify;\n  font-size: 18px;\n}\n\n.authorities_message .image img {\n  border: 4px solid #002147;\n}\n\n.authorities_message .icon .youtube_icon {\n  padding-left: 25px;\n  color: red;\n  font-size: 45px;\n}\n\n.authorities_message .icon .blog_icon {\n  padding-left: 20px;\n  font-size: 45px;\n}\n\n.vision_and_mission {\n  background-image: url(./images/bg-3.jpg);\n  background-position: center center;\n  background-size: cover;\n}\n\n/* Infrastructure CSS */\n.infrastructure ul.nav {\n  position: relative;\n}\n\n.infrastructure .nav .nav-link {\n  color: black;\n}\n\n.infrastructure .nav.nav-pills {\n  justify-content: center;\n  align-items: center;\n}\n\n.infrastructure .nav-pills li {\n  display: block;\n  min-width: 200px;\n}\n\n.infrastructure .nav-pills li .nav-link {\n  font-size: 20px;\n  color: black;\n  text-transform: capitalize;\n  font-weight: 500;\n  display: inline-block;\n  transition: 0.3s;\n  border: 2px solid #ebebeb;\n  background-color: orange;\n  width: 250px;\n}\n\n.infrastructure .nav-pills li .nav-link.active {\n  position: relative;\n  color: white !important;\n  background: #0d6efd;\n}\n\n.infrastructure .nav-pills li .nav-link.active::before {\n  position: absolute;\n  content: \"\";\n  width: 102%;\n  height: 109%;\n  border: 2px solid #c09578;\n  left: -2px;\n  top: -2px;\n  /* border-radius: 2px; */\n}\n\n.infrastructure .tab-content .tab-pane h3 {\n  border-bottom: 2px solid #002147;\n  border-top: 2px solid #002147;\n  margin-top: 30px;\n  padding: 20px 0 25px;\n  text-align: center;\n  color: orange;\n  font-weight: bold;\n}\n\n.infrastructure .tab-content .tab-pane p {\n  font-size: 18px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.infrastructure .tab-content .tab-pane h5 {\n  font-size: 24px;\n  color: maroon;\n  font-weight: bold;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.infrastructure .tab-content .tab-pane ol li {\n  font-size: 18px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.infrastructure .tab-content .tab-pane ul li {\n  font-size: 18px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.virtualTour h3 {\n  font-size: 30px;\n  border-left: 5px solid #00a651;\n  padding-left: 10px;\n  font-weight: bold;\n  margin: 2% 0;\n  color: #002147;\n}\n\n.virtualTour h3 span {\n  color: #00a651;\n}\n\n.fraternity {\n  text-align: center;\n}\n\n.fraternity h2 {\n  color: orange;\n  font-weight: 700;\n}\n\n.fraternity .img-fluid {\n  height: 200px;\n}\n\n.fraternity h6 {\n  padding: 0px 10px;\n  color: maroon;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.fraternity .teacher-name {\n  color: darkblue;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n/*  */\n.Teachers-faculties .teachers-name {\n  color: darkblue;\n  font-weight: bold;\n}\n\n.Teachers-faculties h4 {\n  background-color: orange;\n  padding: 10px 0px;\n  color: #002147;\n  font-weight: bold;\n  font-size: 22px;\n}\n\n.Teachers-faculties h6 {\n  color: maroon;\n  font-weight: bold;\n}\n\n.Teachers-faculties p a {\n  text-decoration: none;\n  color: maroon;\n  font-weight: bold;\n}\n\n.Teachers-faculties p a i {\n  padding-right: 5px;\n}\n\n.teacher-wings-button ul.nav {\n  position: relative;\n}\n\n.teacher-wings-button .nav .nav-link {\n  color: black;\n}\n\n.teacher-wings-button ul li {\n  display: block;\n}\n\n.teacher-wings-button ul li a {\n  font-size: 20px;\n  color: black;\n  text-transform: capitalize;\n  font-weight: 500;\n  display: inline-block;\n  transition: 0.3s;\n  border: 2px solid #ebebeb;\n  min-width: 190px;\n}\n\n.teacher-wings-button ul li a.active {\n  position: relative;\n  color: #c09578 !important;\n}\n\n.teacher-wings-button ul li a.active::before {\n  position: absolute;\n  content: \"\";\n  width: 102%;\n  height: 109%;\n  border: 2px solid #c09578;\n  left: -2px;\n  top: -2px;\n  border-radius: 2px;\n}\n\n.wings-contents .teachers-name {\n  color: darkblue;\n  font-weight: bold;\n}\n\n.wings-contents h4 {\n  background-color: orange;\n  padding: 10px 0px;\n  color: #002147;\n  font-weight: bold;\n  font-size: 22px;\n}\n\n.wings-contents h6 {\n  color: maroon;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.wings-contents p {\n  font-size: 14px;\n}\n\n.wings-contents p a {\n  text-decoration: none;\n  color: maroon;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.admission-policy {\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n\n.admission-policy h3 {\n  color: orange;\n  font-weight: bold;\n}\n\n.admission-policy ol li {\n  padding: 10px 0;\n  font-size: 18px;\n}\n\n.exam-policy {\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n}\n\n.exam-policy table thead tr th {\n  background-color: orange;\n  color: #fff;\n}\n\n.exam-policy table thead tr th h4 {\n  font-weight: bold;\n}\n\n.exam-policy table thead tr th h6 {\n  font-weight: bold;\n}\n\n.hostel-policy {\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n\n}\n\n.hostel-policy h3 {\n  color: orange;\n  font-weight: bold;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.hostel-policy p {\n  font-size: 18px;\n}\n\n.hostel-policy ol li {\n  padding: 8px 0;\n  font-size: 18px;\n}\n\n.hostel-policy .formalitiesHostel {\n  padding-left: 30px;\n}\n\n.exam-policy .table-3 {\n  width: 80%;\n}\n\n/* Admin Login */\n.carousel .carousel-inner .carousel-item img.admin-img {\n  height: 100vh;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 0;\n}\n\n.admin-form {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 30%;\n  background-color: white;\n  padding: 25px;\n  border-radius: 20px;\n}\n\n.sidebar {\n  width: 220px;\n}\n\n.list-group a:hover {\n  cursor: pointer;\n}\n\n.document-form-1 {\n  margin: 20px 50px 50px 50px;\n  width: 91%;\n  background-color: white;\n  padding: 25px;\n  border-radius: 20px;\n  border: 2px solid black;\n}\n\n/* School Magazine */\n.school-magazine {\n  text-align: center;\n}\n\n.school-magazine iframe {\n  width: 900px;\n  height: 475px;\n}\n\n/*  */\n.admission-procedure ul.nav {\n  position: relative;\n}\n\n.admission-procedure .nav .nav-link {\n  color: black;\n}\n\n.admission-procedure .nav.nav-pills {\n  justify-content: center;\n  align-items: center;\n}\n\n.admission-procedure .nav-pills li {\n  display: block;\n  min-width: 200px;\n}\n\n.admission-procedure .nav-pills li .nav-link {\n  font-size: 20px;\n  color: black;\n  text-transform: capitalize;\n  font-weight: 500;\n  display: inline-block;\n  transition: 0.3s;\n  border: 2px solid #ebebeb;\n  background-color: orange;\n  width: 250px;\n}\n\n.admission-procedure .nav-pills li .nav-link.active {\n  position: relative;\n  color: white !important;\n  background: #0d6efd;\n}\n\n.admission-procedure .nav-pills li .nav-link.active::before {\n  position: absolute;\n  content: \"\";\n  width: 102%;\n  height: 109%;\n  border: 2px solid #c09578;\n  left: -2px;\n  top: -2px;\n  /* border-radius: 2px; */\n}\n\n.admission-procedure .tab-content .tab-pane h3 {\n  border-bottom: 2px solid #002147;\n  border-top: 2px solid #002147;\n  margin-top: 30px;\n  padding: 20px 0 25px;\n  text-align: center;\n  color: orange;\n  font-weight: bold;\n}\n\n.admission-procedure .tab-content .tab-pane p {\n  font-size: 18px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.admission-procedure .tab-content .tab-pane h5 {\n  font-size: 24px;\n  color: maroon;\n  font-weight: bold;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.admission-procedure .tab-content .tab-pane ol li {\n  font-size: 18px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.admission-procedure .tab-content .tab-pane ul li {\n  font-size: 18px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n/* Achievement */\n.all-achievement ul.nav {\n  position: relative;\n}\n\n.all-achievement .nav .nav-link {\n  color: black;\n  text-align: center;\n}\n\n.all-achievement .nav {\n  justify-content: center;\n  align-items: center;\n}\n\n.all-achievement li .nav-link {\n  font-size: 20px;\n  color: black;\n  text-transform: capitalize;\n  font-weight: bold;\n  display: inline-block;\n  transition: 0.3s;\n  border: 2px solid #ebebeb;\n  background-color: orange;\n  width: 180px;\n}\n\n.all-achievement li .nav-link.active {\n  position: relative;\n  color: white !important;\n  background: #0d6efd;\n}\n\n.all-achievement li .nav-link.active::before {\n  position: absolute;\n  content: \"\";\n  width: 102%;\n  height: 109%;\n  border: 2px solid #c09578;\n  left: -2px;\n  top: -2px;\n  /* border-radius: 2px; */\n}\n\n.card-date {\n  padding: 5px;\n  background: url(./images/date-box.svg) no-repeat center center;\n  margin: auto;\n  background-size: contain;\n}\n\n.card-date .year {\n  font-weight: 700;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 20px;\n}\n\n.card-date .month {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 100%;\n  text-align: center;\n\n}\n\n.card-date .day {\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 100%;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n/* School Circular */\n.school-circular {\n  display: flex;\n  justify-content: center;\n}\n\n.school-circular .table {\n  width: 70%;\n  display: inline-table;\n}\n\n.school-circular .table .download_heading {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.school-circular table thead th.action {\n  width: 100px;\n}\n\n.school-circular table tbody tr td a button.viewbutton {\n  max-width: 45%;\n  margin-right: 2px;\n}\n\n/* Add this to your CSS */\n.lightbox-js img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.sidebar .list-group.list-group-flush a {\n  background-color: rgb(48, 42, 42);\n}\n\n.sidebar .list-group-item {\n  background-color: rgb(48, 42, 42);\n  color: white;\n  border: none;\n}\n\n/* Student Council CSS */\n.student-council-image img {\n  opacity: 0;\n  animation: fadeIn 2s ease-in forwards;\n  transform: scale(1, 1);\n  transition: 0.2s ease-in-out;\n}\n\n.student-council-image img:hover {\n  transform: scale(1.1, 1.1);\n}\n\n.student_council_table table {\n  width: 85%;\n  margin-top: 15px;\n}\n\n.student_council_table .table>:not(caption)>*>* {\n  padding: .1rem .1rem;\n}\n\n.student_council_table table thead tr th {\n  background-color: orange;\n}\n\n.student_council_table table tbody {\n  vertical-align: middle;\n}\n\n.student_council_table table tbody tr td.house-name {\n  padding-left: 15px;\n}\n\n\n/* BackToTopButton.css */\n.back-to-top-btn {\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  cursor: pointer;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 0.3s ease;\n  opacity: 0.8;\n  z-index: 9999;\n}\n\n.back-to-top-btn:hover {\n  opacity: 1;\n  background-color: #0056b3;\n  /* Darker shade on hover */\n}\n\n.newsletter {\n  flex: 1;\n  /* Takes up remaining space */\n}\n\n.school_news {\n  flex: 1;\n  /* Takes up remaining space */\n}\n\n.Achievement {\n  flex: 1;\n  /* Takes up remaining space */\n}\n\n.download {\n  flex: 1;\n  /* Takes up remaining space */\n}\n\n.school_circular {\n  flex: 1;\n  /* Takes up remaining space */\n}\n\n.TramsferCertificate {\n  flex: 1;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .icons {\n    display: none;\n  }\n\n  .contact-header {\n    display: none;\n  }\n\n  .contact-header ul li {\n    padding: 0;\n    font-size: 13px;\n  }\n\n  .contact-header .laptop ul li {\n    font-size: 13px;\n    padding-right: 5px;\n  }\n\n  .social-icons {\n    display: none;\n  }\n\n  .navbar-brand img {\n    width: 250px;\n  }\n\n  .dropdown-menu {\n    display: none;\n  }\n\n  .dropdown {\n    .dropdown-menu {\n      transition: all ease .5s;\n      overflow: hidden;\n      transform-origin: top center;\n      transform: scale(1, 0);\n      display: none;\n    }\n\n    &:hover {\n      .dropdown-menu {\n        transform: scale(1);\n      }\n    }\n  }\n\n  .slider video {\n    height: 128px;\n  }\n\n  .news-update h3 {\n    font-size: 20px;\n    padding: 0;\n    margin: 0;\n  }\n\n  .news-update-list {\n    margin: 0;\n    padding: 0;\n  }\n\n  .news-update-list ul li {\n    padding-top: 10px;\n  }\n\n  .welcome-dps h3 {\n    font-size: 25px;\n  }\n\n  .welcome-dps p {\n    font-size: 15px;\n    background-size: contain;\n    animation-name: none;\n  }\n\n  .notice-circular {\n    animation-name: none;\n  }\n\n  .about-img img {\n    height: 250px;\n  }\n\n  .counter-content h2 {\n    font-size: 33px;\n  }\n\n  .counter {\n    justify-content: flex-start;\n    padding: 10px 0;\n  }\n\n  .counter-one::before {\n    content: \"\";\n    display: none;\n  }\n\n  .counter-three::before {\n    content: \"\";\n    display: none;\n  }\n\n  .counter-two::before {\n    content: \"\";\n    display: none;\n  }\n\n  .counter-img {\n    padding: 0px 70px;\n  }\n\n  /* About */\n  .about-dps h3 {\n    font-size: 25px;\n    font-weight: 500;\n  }\n\n  .dps-vision h3 {\n    font-size: 25px;\n    font-weight: 500;\n  }\n\n  .mission-dps h3 {\n    font-size: 25px;\n    font-weight: 500;\n  }\n\n  .principal-message h3 {\n    font-size: 25px;\n    font-weight: 500;\n  }\n\n  .principal-message h5 {\n    font-size: 17px;\n  }\n\n  .about-dps-society h3 {\n    font-size: 25px;\n    font-weight: 500;\n  }\n\n  /* At a Glance */\n  .atglance h3 {\n    font-size: 25px;\n  }\n\n  .atglance p {\n    font-size: 16px;\n  }\n\n  .ataglance-responsive-image {\n    display: block;\n    /* Show the responsive image on smaller screens */\n    width: 100%;\n    height: auto;\n  }\n\n  .atgalnce-images {\n    display: none;\n    /* Hide the images div on smaller screens */\n  }\n\n  /*  */\n  .fraternity h2 {\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .fraternity h6 {\n    padding: 0px 20px;\n  }\n\n  .Teachers-faculties p {\n    font-weight: 500;\n  }\n\n\n  /*  */\n  footer {\n    padding: 0px 0px 30px 0px;\n  }\n\n  .footer {\n    padding: 0px;\n    border: 0px;\n  }\n\n  .footer .get-in-touch {\n    border-right: 0px groove #6a83a0;\n    text-align: center;\n  }\n\n\n  .footer .footer-right {\n    border-right: 0;\n  }\n\n  .footer h6 {\n    border-top: 1px solid #6a83a0;\n    padding-top: 35px;\n    margin-top: 35px;\n  }\n\n  .footer-1 h6 {\n    border-top: 0;\n  }\n\n  /*  */\n  .mpd {\n    padding: 0;\n  }\n\n  table {\n    max-width: 100%;\n    margin-top: 10px;\n    font-size: 12px;\n  }\n\n  /*  */\n  .payment-note ul li {\n    font-size: 15px;\n  }\n\n  /*  */\n  .form-button {\n    text-align: center !important;\n  }\n\n  .form-button input {\n    width: 30%;\n  }\n\n  /* school Rules */\n  .school-rules-heading h3 {\n    font-size: 15px;\n  }\n\n  .school-rules p {\n    font-size: 16px;\n  }\n\n  .school-rules ol li {\n    font-size: 15px;\n  }\n\n  .events-gallery h2 {\n    font-size: 30px;\n    margin: 0 0 20px;\n  }\n\n  /*  */\n  /* .authorities_message h3 {\n    margin-left: 10px;\n  } */\n  .bisque_authoritites_message {\n    margin-top: 50px;\n  }\n\n  .blue_authorities_message {\n    margin-top: 50px;\n  }\n\n  .authorities_message .image img {\n    width: 230px;\n    margin-top: -2%;\n    padding-left: 0;\n  }\n\n  .authorities_message .image img.director-image {\n    margin-top: 0;\n  }\n\n  .authorities_message .message h2 {\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  .authorities_message .image h2 {\n    padding-left: 0;\n    ;\n  }\n\n  .authorities_message .message p {\n    text-align: justify;\n    font-size: 16px;\n  }\n\n  .authorities_message .image h3 {\n    padding-left: 0;\n    font-size: 20px;\n  }\n\n  .authorities_message .icon .youtube_icon {\n    padding-left: 60px;\n  }\n\n  .authorities_message .icon .blog_icon {\n    padding-left: 20px;\n  }\n\n  .virtualTour iframe {\n    height: 300px;\n  }\n\n  /*  */\n  .bottom-layer {\n    display: block;\n    background: #9e801a;\n    position: fixed;\n    bottom: 0px;\n    width: 100% !important;\n    height: 40px;\n    color: #fff;\n    text-align: center;\n    z-index: 999999;\n  }\n\n  .bottom-layer a {\n    color: white;\n    text-decoration: none;\n    font-size: 13px;\n  }\n\n  .explore-us h3 {\n    font-size: 30px;\n    font-weight: 500;\n  }\n\n  .explore-us iframe {\n    height: 350px;\n  }\n\n  .exam-policy table.table-2 {\n    font-size: 6px !important;\n  }\n\n  .exam-policy .table-3 {\n    width: 100%;\n  }\n\n  .sidebar {\n    width: 120px;\n  }\n\n  .school-magazine iframe {\n    width: 320px;\n    height: 400px;\n  }\n\n  .admission-procedure .nav {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n\n  .admission-procedure .tab-content {\n    padding: 0 20px;\n  }\n\n  .all-achievement .nav {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .all-achievement li .nav-link {\n    width: 200px;\n  }\n\n  .school-circular {\n    display: block;\n  }\n\n  .school-circular table {\n    width: 100% !important;\n  }\n\n  .school-circular .table .download_heading {\n    font-size: 15px;\n    font-weight: bold;\n  }\n\n\n  .slick-slider button.slick-prev {\n    left: -10px;\n  }\n\n  .slick-slider button.slick-next {\n    right: -10px;\n  }\n\n  .student_council_table table {\n    width: 100%;\n  }\n\n  .student_council_table .table>:not(caption)>*>* {\n    padding: 0px;\n  }\n\n  .student_council_table table tbody tr td.house-name {\n    padding: 5px;\n  }\n\n  .fee-structure table thead tr th h6 {\n    font-size: 16px;\n  }\n\n  .fee-structure table tbody tr td {\n    font-size: 14px;\n  }\n\n  .subject-combination table thead tr th {\n    font-size: 16px;\n  }\n\n  .subject-combination table tbody tr td {\n    font-size: 14px;\n  }\n\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .contact-header {\n    display: none;\n  }\n\n  .social-icons {\n    display: none;\n  }\n\n  #offcanvasRight {\n    width: 50%;\n  }\n\n  .dropdown-menu {\n    display: none;\n  }\n\n  .dropdown {\n    .dropdown-menu {\n      transition: all ease .5s;\n      overflow: hidden;\n      transform-origin: top center;\n      transform: scale(1, 0);\n      display: none;\n    }\n\n    &:hover {\n      .dropdown-menu {\n        transform: scale(1);\n      }\n    }\n  }\n\n  .authorities_message .image img {\n    width: 230px;\n    margin-top: -20%;\n    padding-left: 0;\n  }\n\n  .authorities_message .images img {\n    width: 230px;\n    padding-left: 0;\n  }\n\n  .authorities_message .image h2 {\n    padding-left: 0;\n    ;\n  }\n\n  .authorities_message .image h3 {\n    padding-left: 0;\n    font-size: 20px;\n  }\n\n  .counter {\n    justify-content: flex-start;\n  }\n\n  .counter-one::before {\n    content: \"\";\n    position: absolute;\n    top: 8px;\n    right: 12px;\n    background-color: #e1dddd;\n    width: 3px;\n    height: 50px;\n  }\n\n  .counter-two::before {\n    content: \"\";\n    display: none;\n    position: absolute;\n    top: 10px;\n    right: 20px;\n    background-color: #e1dddd;\n    width: 3px;\n    height: 50px;\n  }\n\n  .counter-three::before {\n    content: \"\";\n    position: absolute;\n    top: 8px;\n    right: 12px;\n    background-color: #e1dddd;\n    width: 3px;\n    height: 50px;\n  }\n\n  /* At a Glance */\n  .atglance h3 {\n    text-align: center;\n    font-size: 30px;\n    font-weight: 500;\n    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;\n  }\n\n  .atglance p {\n    text-align: justify;\n    font-size: 18px;\n  }\n\n  .ataglance-responsive-image {\n    display: block;\n    /* Show the responsive image on smaller screens */\n    width: 100%;\n    height: auto;\n  }\n\n  .atgalnce-images {\n    display: none;\n    /* Hide the images div on smaller screens */\n  }\n\n  .exam-policy .table-3 {\n    width: 100%;\n  }\n\n  .sidebar {\n    width: 120px;\n  }\n\n  .school-magazine iframe {\n    width: 650px;\n    height: 550px;\n  }\n\n  .admission-procedure .nav.nav-pills {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n\n  .admission-procedure .tab-content {\n    padding: 0 20px;\n  }\n\n  .slick-slider button.slick-prev {\n    left: -10px;\n  }\n\n  .slick-slider button.slick-next {\n    right: -10px;\n  }\n\n  .student_council_table table {\n    width: 100%;\n  }\n\n  footer {\n    padding: 0px 0px 30px 0px;\n  }\n\n  .footer {\n    padding: 0px;\n    border: 0px;\n  }\n\n  .footer .get-in-touch {\n    border-right: 0px groove #6a83a0;\n    text-align: center;\n  }\n\n  .footer .footer-right {\n    border-right: 0;\n  }\n\n  .footer h6 {\n    border-top: 1px solid #6a83a0;\n    padding-top: 35px;\n    margin-top: 35px;\n  }\n\n  .footer-1 h6 {\n    border-top: 0;\n  }\n\n}\n\n\n@media only screen and (min-width: 992px) and (max-width: 1200px) {\n  .contact-header .laptop ul li {\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n\n  .navbar-brand img {\n    width: 220px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
